import { c as _c } from "react/compiler-runtime";
import React from "react";
import HoverCard from "./HoverCard";
import WaveProfileTooltip from "@/components/waves/utils/profile/WaveProfileTooltip";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
interface WaveProfileTooltipWrapperProps {
  readonly waveId: string;
  readonly initialWave?: ApiWaveMin | null;
  readonly fallbackName?: string | undefined;
  readonly children: React.ReactElement;
  readonly placement?: "top" | "bottom" | "left" | "right" | "auto" | undefined;
}
export default function WaveProfileTooltipWrapper(t0) {
  const $ = _c(15);
  const {
    waveId,
    initialWave: t1,
    fallbackName,
    children,
    placement: t2
  } = t0;
  const initialWave = t1 === undefined ? null : t1;
  const placement = t2 === undefined ? "auto" : t2;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t3;
  if ($[0] !== fallbackName || $[1] !== initialWave?.name || $[2] !== waveId) {
    t3 = initialWave?.name.trim() ?? fallbackName?.trim() ?? `Wave ${waveId}`;
    $[0] = fallbackName;
    $[1] = initialWave?.name;
    $[2] = waveId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const waveLabelSource = t3;
  if (hasTouchScreen) {
    let t4;
    if ($[4] !== children) {
      t4 = <>{children}</>;
      $[4] = children;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  let t4;
  if ($[6] !== fallbackName || $[7] !== initialWave || $[8] !== waveId) {
    t4 = <WaveProfileTooltip waveId={waveId} initialWave={initialWave} fallbackName={fallbackName} />;
    $[6] = fallbackName;
    $[7] = initialWave;
    $[8] = waveId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = `Wave details for ${waveLabelSource}`;
  let t6;
  if ($[10] !== children || $[11] !== placement || $[12] !== t4 || $[13] !== t5) {
    t6 = <HoverCard content={t4} ariaLabel={t5} placement={placement} delayShow={500} delayHide={0}>{children}</HoverCard>;
    $[10] = children;
    $[11] = placement;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}